export const EXTERNAL_PARTICIPANT_ID_PREFIX = 'anon_external_';
